var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"YKEditorV2ContainerRef",staticClass:"YKEditorV2Container"},[_c('div',{staticClass:"YKEditorV2"})])}
var staticRenderFns = []

export { render, staticRenderFns }